import { createSelector } from 'reselect';
import { getSelectorRoot } from 'utils/selectors';

const getBetSlip = getSelectorRoot('betSlip');

const getOddFormat = getBetSlip('oddFormat');
const getTotalOddsReturn = getBetSlip('totalOddsReturn');
const getEventPrevOdds = getBetSlip('eventsPrevOdds');
const getBetsTotalOdds = getBetSlip('betsTotalOdds');

const getEventPrevOddById = (eventId: number) =>
  createSelector([getEventPrevOdds], prevOdds => prevOdds[eventId]);

export {
  getOddFormat,
  getBetsTotalOdds,
  getTotalOddsReturn,
  getEventPrevOddById
};
